interface Config {
    apiUrl: string;
    basePath: string;
}

const config: Config = {
     apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8100',
     basePath: process.env.REACT_APP_BASE_PATH || '/',

};
console.log('config:', config
// 'env:', process.env.REACT_APP_API_URL
);
export default config; 